module.exports = __webpack_public_path__ + "img/acasia-upper.57ab23b5.svg";